function removeUnusedMUPFields(obj) {
  const { property_id, unit_id, room_id, ...toSubmit } = obj;
  return toSubmit;
}

export default removeUnusedMUPFields;
